import { routes } from "consts";

export const breadcrumbs = {
  COURSE_GROUPS: [{ title: "Grupy kursów" }],
  COURSE_GROUP_EDIT: (courseGroupName: string) => [
    { title: "Grupy kursów", path: routes.COURSE_GROUPS },
    { title: courseGroupName },
  ],
  COURSE_STUDENTS: (
    courseGroupName: string,
    courseGroupId: string | number,
    editionName: string,
    courseId: number | string,
    variant?: string,
  ) => [
    { title: "Grupy kursów", path: routes.COURSE_GROUPS },
    { title: courseGroupName, path: routes.COURSE_GROUPS_EDIT_COURSES(courseGroupId.toString()) },
    { title: [editionName, variant].filter(Boolean).join(" · "), path: routes.COURSES_MANAGE(courseId) },
    { title: "Kursanci" },
  ],
  COURSE_ATTENDANCE: (
    courseGroupName: string,
    courseGroupId: string | number,
    editionName: string,
    courseId: number | string,
    variant?: string,
  ) => [
    { title: "Grupy kursów", path: routes.COURSE_GROUPS },
    { title: courseGroupName, path: routes.COURSE_GROUPS_EDIT_COURSES(courseGroupId.toString()) },
    { title: [editionName, variant].filter(Boolean).join(" · "), path: routes.COURSES_MANAGE(courseId) },
    { title: "Obecność" },
  ],
};
